import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useBooking } from "@/context/BookingContext";
import { api } from "@/lib/api";

export default function Pricing() {
  const { T, lang } = useLanguage();
  const { openBooking } = useBooking();
  const [services, setServices] = useState([]);
  const [pacotes, setPacotes] = useState([]);

  useEffect(() => {
    api.get("/public/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/public/pacotes").then((r) => setPacotes(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-16 pb-10 px-6 lg:px-16 max-w-[1200px] mx-auto" data-testid="pricing-page">
      <div className="mb-16 max-w-lg">
        <p className="text-[11px] tracking-[0.25em] uppercase text-[#9B6179] mb-3">{T.pricing.eyebrow}</p>
        <h1 className="font-serif text-4xl lg:text-5xl text-[#9B6179] mb-4">{T.pricing.title}</h1>
        <p className="text-base text-[#090708]/55">{T.pricing.subtitle}</p>
      </div>

      <div className="flex flex-col divide-y divide-[#090708]/8 mb-24">
        {services.map((s, i) => (
          <div key={s.id} className="grid grid-cols-1 md:grid-cols-12 items-center gap-4 py-7" data-testid={`pricing-service-${s.slug}`}>
            <span className="hidden md:block md:col-span-1 font-serif text-sm text-[#E8C47A]">{String(i + 1).padStart(2, "0")}</span>
            <p className="md:col-span-6 font-serif text-2xl text-[#090708]">{lang === "pt" ? s.name_pt : s.name_fr}</p>
            <p className="md:col-span-2 text-[11px] tracking-widest uppercase text-[#090708]/40">{T.pricing.from}</p>
            <p className="md:col-span-1 font-serif text-xl text-[#090708]">{s.price}€</p>
            <button
              onClick={() => openBooking(s.id)}
              data-testid={`pricing-book-${s.slug}`}
              className="md:col-span-2 justify-self-start md:justify-self-end inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#090708] border-b border-[#090708]/20 pb-1 hover:border-[#E8C47A]"
            >
              {T.pricing.book} <ArrowUpRight className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>

      {pacotes.length > 0 && (
        <div>
          <h2 className="font-serif text-2xl lg:text-3xl text-[#9B6179] mb-8">{T.pricing.pacotes_title}</h2>
          <div className="grid sm:grid-cols-2 gap-px bg-[#090708]/8">
            {pacotes.map((p) => (
              <div key={p.id} className="bg-[#9B6179] text-[#F7F0E8] p-8" data-testid={`pacote-${p.id}`}>
                <p className="font-serif text-2xl text-[#F7F0E8] mb-2">{lang === "pt" ? p.name_pt : p.name_fr}</p>
                <p className="text-sm text-[#F7F0E8]/50 mb-6">{lang === "pt" ? p.description_pt : p.description_fr}</p>
                <p className="font-serif text-3xl text-[#E8C47A]">{p.total_price}€</p>
                <p className="text-[11px] tracking-widest uppercase text-[#F7F0E8]/40 mt-1">{p.sessions_count} {T.pricing.sessions} · {T.pricing.total}</p>
              </div>
            ))}
          </div>
        </div>
      )}
      <p className="text-xs text-[#090708]/40 mt-16 max-w-md">{T.pricing.note}</p>
    </div>
  );
}
